import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65" width="1em" height="1em">
    <circle cx={32.5} cy={32.5} r={32.5} fill="fj-icons-bg-color" />
    <path
      d="M27.305 47.926L14.423 36.271a2.793 2.793 0 113.748-4.143l8.825 7.986 19.831-21.011a2.788 2.788 0 013.948-.114 2.792 2.792 0 01.115 3.948l-23.585 24.99z"
      fill="fj-icons-primary-color"
    />
  </svg>
);

const StatusSuccess = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default StatusSuccess;
